<div class="app__internal--links app__role--players--card" id="add-api-key-managed-container">
  @if (isDataLoading) {
    <div class="ph-item w-full loader-body-item m-0 p-0 border-0">
      <div class="ph-col-12 p-0 pt-6">
        <div class="ph-row">
          <div class="ph-col-4 h-[10px]"></div>
          <div class="ph-col-6 empty"></div>
          <div class="ph-col-2 h-[10px]"></div>
        </div>
      </div>
    </div>
  }
  @if (!isDataLoading) {
    <mat-dialog-content class="mat-dialog-content">
      <mat-accordion class="prevent-click" [@.disabled]="true">
        <mat-expansion-panel
          hideToggle
          [expanded]="true"
          class="parametersPanel shadow-none rounded-t-none rounded-b-none mt-[-10px] px-1"
          [ngClass]="apiMotorValueList?.length == 0 ? 'setEmptyPanelDefault' : ''"
          >
          <mat-expansion-panel-header class="h-8 disable_ripple">
            <mat-panel-title>
              <div class="header-section">
                <p (click)="$event.stopPropagation()">
                  Vehicle Database (Automobile Data)
                </p>
                @if (mode != 'view' && allowEditPermission) {
                  <button
                    class="app__internal--links--add--btn app__centered-item w-fit leading-[34px]"
                    (click)="$event.stopPropagation();addEditMotorData();"
                    >
                  <span style="color: #25508e; font-size: 16px;position: relative;" class="material-icons">settings</span>
                    <span class="relative"> Manage </span>
                  </button>
                }
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mt-4" style="margin-left: -24px; margin-right: -24px;">
            @if (apiMotorValueList.length == 0) {
              <div  class="flex-center border border-[#D3DCE8] p-4 rounded-lg gap-2" >
                <img src="assets/images/zero-mx-data.svg" />
                <span  class="m-0 font-semibold text-xs text-[#18191C]" >No <span class="font-bold text-[#25508E]">live data feeds </span> to show</span>
              </div>
            }
            <div class="folder-view__association-files max-w-full w-full">
              <div class="association-files-table flex fl-col width-100per">
                <div class="width-100per" style="overflow-x: hidden;">
                  @for (subLink of apiMotorValueList; track subLink; let i = $index) {
                    <div
                      class="association-files-table__body mb-0 width-100per"
                      style="background: #ffffff"
                      >
                      <div style="display: flex; justify-content: space-between" (click)="$event.stopPropagation();addEditMotorData();">
                        <div
                          class="body-card flex"
                          style="padding: 16px!important; width: 100%; border-radius: 8px; justify-content: space-between"
                          >
                          <div class="test-zeropostion">
                            <div class="flex-center" >
                              <img src="assets/images/vehicle-db-logo.svg" alt="" />
                              <p
                                class="name-title text-truncate text-sm font-semibold text-[#010B18]"
                                style="line-height: 30px;margin-left: 8px;"
                                >
                                {{subLink.payload?.make}}
                              </p>
                            </div>
                          </div>
                          <button
                            (click)="$event.stopPropagation();editMotor(subLink);"
                            class="more-vote-btn cursor-pointer flex-center"
                            style="position: relative;  
                            background: #E2F9E4;
                            border-radius: 4px;
                            padding: 3px 6px;
                            height: fit-content;
                            width: fit-content;"
                            mat-icon-button
                            >
                            <span class="material-icons" style="position: relative;color: #59AB62;font-size: 24px;">link</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-dialog-content>
  }
</div>
